/**
 * Enum for openned error table fields
 * @readonly
 * @enum {Array}
 */
export const OPENNED_ERROR_TABLE_FIELDS = Object.freeze([
	{ key: 'id', label: 'Issue ID', class: 'issue-id-col' },
	{ key: 'type', label: 'Issue type', class: 'issue-type-col th-mw-200' },
	{ key: 'message', label: 'Issue summary', class: 'issue-summary-col th-mw-250' },
	{ key: 'channel', label: 'Channel', class: 'channel-col th-mw-150' },
	{ key: 'reported_at', label: 'Report date', class: 'report-at-col th-mw-180' },
	{ key: 'action_openned_error', label: '', class: 'action-col th-mw-150' },
]);

/**
 * Enum for resolved error table fields
 * @readonly
 * @enum {Array}
 */
export const RESOLVED_ERROR_TABLE_FIELDS = Object.freeze([
	{ key: 'id', label: 'Issue ID', class: 'issue-id-col' },
	{ key: 'type', label: 'Issue type', class: 'issue-type-col th-mw-200' },
	{ key: 'message', label: 'Issue summary', class: 'issue-summary-col th-mw-250' },
	{ key: 'channel', label: 'Channel', class: 'channel-col th-mw-150' },
	{ key: 'reported_at', label: 'Report date', class: 'report-at-col th-mw-180' },
	{ key: 'resolved_at', label: 'Resovled date', class: 'resolve-at-col th-mw-180' },
	{ key: 'resolved_by', label: 'Resovled by', class: 'resolve-by-col' },
	{ key: 'action_resolved_error', label: '', class: 'action-col th-mw-150' },
]);

export const ERROR_STATUS = Object.freeze({
	EXTERNAL_PRODUCT_SYNC_FAILED: 'external_product_sync_failed',
	ORDER_SYNC_FAILED: 'order_sync_failed',
	UPDATE_PRODUCT_FAILED: 'update_product_failed',
});

/**
 * Enum for sku status options
 * @readonly
 * @enum {String}
 */
export const ERROR_TYPE_OPTIONS = Object.freeze([
	{
		name: 'All issue types',
		value: null,
	},
	{
		name: 'External product sync failed',
		value: ERROR_STATUS.EXTERNAL_PRODUCT_SYNC_FAILED,
	},
	{
		name: 'Order sync failed',
		value: ERROR_STATUS.ORDER_SYNC_FAILED,
	},
	{
		name: 'Update product failed',
		value: ERROR_STATUS.UPDATE_PRODUCT_FAILED,
	},
]);

// mapping order title, use with CBadge component
export const ERROR_TITLE = {
	ERROR: {
		[ERROR_STATUS.EXTERNAL_PRODUCT_SYNC_FAILED]: 'External product sync failed',
		[ERROR_STATUS.ORDER_SYNC_FAILED]: 'Order sync failed',
		[ERROR_STATUS.UPDATE_PRODUCT_FAILED]: 'Update product failed',
	},
};
